import { h } from 'preact';
import * as BaseComp from 'components/pages/home/home.js';
import s from 'components/pages/home/home.sss';

export default class Home extends BaseComp.default {
	getExtraContent() {
		let url = 'https://greenwichentertainment.us17.list-manage.com/subscribe/post?u=66fa7b2b379ec4c844d7dcb0f&amp;id=6b88dd1937';
		let u = '66fa7b2b379ec4c844d7dcb0f';
		let id = '6b88dd1937';
		let signup = (
			<form class={s.signup} action={url} method="post" name="mc-embedded-subscribe-form" target="_blank" novalidate>
				<label for="mce-EMAIL">SIGN UP FOR UPDATES</label>
				<input type="email" class={s.email} value="" name="EMAIL" id="mce-EMAIL" placeholder="email address" required />
				<input type="text" class={s.hidden} name={'b_'+u+'_'+id} tabindex="-1" value="" aria-hidden="true" />
				<input type="submit" class={s.button} value="Subscribe" name="subscribe" />
			</form>
		);

		return signup;
	}
}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
